import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import ReactLoading from 'react-loading';
import {connect} from 'react-redux';
import {getFormValues, reduxForm} from 'redux-form';

import {dashbordInfo} from '../../../../common/DashboardDef.js';
import {commonOperations} from '../../../../reducks/common';
import withRouter from '../../../organisms/withRouter';


const styles = (theme) => ({
  panel: {
    border: '2pt solid #C8C8CB',
    borderRadius: '5%',
    margin: '5px',
    background: '#fdfdfd',
    height: 'auto',
    width: '240px',
    textAlign: 'center',
  },
  panelname: {
    color: 'black',
    marginTop: '10px',
    marginBottom: '10px',
    fontSize: '12pt',
    height: '20px',
  },
  fields: {
    fontWeight: 'bold',
    paddingBottom: '0px',
    marginBottom: '7px',
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      fontSize: '30pt',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '25pt',
    },
  },
});

/**
 * ダッシュボード
 * 画面ID:SCZ1002
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.Tabs = [];
    this.state = {
      counter: [],
      loading: [],
    };
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      let index = 0;
      const DashBord = dashbordInfo();
      this.Tabs = DashBord;
      for (const elem of this.Tabs) {
        for (const rows of elem.parts) {
          for (const part of rows) {
            index++;
            if (part.visible) {
              this.getCount(part, index);
            }
          }
        }
      }
    } catch (error) {
      this.sysErr();
    }
  }

  sysErr = () => {
    this.props.doShowMessage({
      message: {id: 'TKSCS00011E', values: ['未処理件数', '取得']},
      action: () => {
        this.props.navigate('/login');
      },
    });
  };

  /**
   * 遷移
   * @param {*} pathname 遷移先
   */
  doTransition = async (pathname) => {
    try {
      this.props.navigate({pathname: pathname});
    } catch (error) {
      this.sysErr();
    }
  };

  /**
   * 件数取得
   * @param {*} part 定義情報
   * @param {*} index インデックス
   */
  getCount = async (part, index) => {
    const counter = this.state.counter;
    const loading = this.state.loading;
    let result = {};
    if (part.cnt) {
      if (part.cnt.apiName === '-') {
        result['count'] = '-';
      } else {
        // const response = await postRequest('v1.0/' + part.cnt.apiName, part.cnt.condition);
        // if (!response || response.status != HttpStatusCode.Ok) {
        //   result['count'] = '-';
        // } else {
        //   result['count'] = response.data;
        // }
        result['count'] = 5;
      }
    } else {
      result['count'] = '-';
    }
    if (part.expired) {
      if (part.expired.apiName === '-') {
        result['expired'] = '-';
      } else {
        // const response = await postRequest('v1.0/' + part.expired.apiName, part.expired.condition);
        // if (!response || response.status != HttpStatusCode.Ok) {
        //   result['expired'] = '-';
        // } else {
        //   result['expired'] = response.data;
        // }
        result['expired'] = 3;
      }
    } else {
      result['expired'] = '-';
    }
    counter[index] = result;
    loading[index] = false;
    this.setState({counter: counter});
    this.setState({loading: loading});
    return result;
  };

  render() {
    const {classes, handleSubmit} = this.props;
    let tabElems = [];
    let index = 0;
    for (const elem of this.Tabs) {
      let partsElems = [];
      let parts;
      for (const rows of elem.parts) {
        let partElems = [];
        let partElem;
        for (const part of rows) {
          index++;
          // visibleがfalseの場合、パネルを描画しない
          if (!part.visible) {
            continue;
          }

          let subTitle;
          let countResult;
          if (!part.cnt && !part.expired) {
            countResult = <Grid container
              justifyContent="center"
              alignItems="flex-start"
              spacing={0}
            >
            </Grid>;
          } else {
            subTitle = <Grid container
              justifyContent="center"
              alignItems="center"
              spacing={0}
              style={{borderBottom: part.flag ? '1px solid #C8C8CB' : ''}}
            >
              <Grid key="keyCntTitle" item sm={6} style={{borderRight: part.flag ? '1px solid  #C8C8CB' : ''}}>
                <Box
                  display="flex"
                  justifyContent="center"
                  lineHeight="normal"
                  m={1}
                  className={classes.panelname}>
                  <span>{part.cnt.apiTitle}</span>
                </Box>
              </Grid>
              {part.flag && <Grid key="keyExpiredTitle" item sm={6}>
                <Box
                  display="flex"
                  justifyContent="center"
                  lineHeight="normal"
                  m={1}
                  className={classes.panelname}>
                  <span>{part.expired.apiTitle}</span>
                </Box>
              </Grid>}
            </Grid>;

            if (this.state.loading && this.state.loading[index] === false) {
              countResult = <Grid container
                justifyContent="center"
                alignItems="center"
                spacing={0}
              >
                <Grid key="keyApprovalOver" item sm={6} style={{borderRight: part.flag ? '1px solid  #C8C8CB': ''}}>
                  <Typography component="div">
                    <Box
                      display="flex"
                      justifyContent="center"
                      lineHeight="normal"
                      m={1}
                      className={classes.fields}>
                      <span>{this.state.counter[index].expired}</span>
                    </Box>
                  </Typography>
                </Grid>
                {part.flag && <Grid key="keyApproval" item sm={6}>
                  <Typography component="div">
                    <Box
                      display="flex"
                      justifyContent="center"
                      lineHeight="normal"
                      m={1}
                      className={classes.fields}>
                      <span>{this.state.counter[index].count}</span>
                    </Box>
                  </Typography>
                </Grid>}
              </Grid>;
            } else {
              countResult = <Grid container
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}
              >
                <ReactLoading type="spin" color="gray"/>
              </Grid>;
            }
          }
          const titleWithBreaks = (
            <React.Fragment key={'keyWithBreaks'+part.title+index}>
              <u className={classes.panelname}>{part.title}</u>
            </React.Fragment>
          );

          partElem = (
            <Grid container direction="column" className={classes.panel} spacing={0}>
              <Grid item key="keyApproval" style={{borderBottom: '1px solid #C8C8CB'}}>
                <Link
                  component="button"
                  variant="body2"
                  id="idApproval"
                  name="Approval"
                  className={classes.panelname}
                  onClick={handleSubmit(async () =>
                    await this.doTransition(
                        part.pathname, part.gmnId, part.cnt.condition))}
                >
                  {titleWithBreaks}
                </Link>
              </Grid>
              <Grid item style={{marginTop: '0px'}}>
                {subTitle}
              </Grid>
              <Grid item style={{marginTop: '0px'}}>
                {countResult}
              </Grid>
            </Grid>
          );
          partElem = <Grid container spacing={1} key={'key'+elem.title} xs={4}>
            {partElem}
          </Grid>;
          partElems.push(partElem);
        }
        parts = partElems;
        partsElems.push(parts);
      }

      tabElems = partsElems;
    }

    return (
      <form>
        <Grid
          container
          justifyContent="center"
          alignItems="flex-start"
          direction="row"
          spacing={1}
        >
          {tabElems}
        </Grid>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
};

const FORM_NAME = 'dashboard';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
